import { z } from 'zod'

import { lenientList, moneySchema } from '@/schemas/common'

/**
 * The rail's "Prices today": one row per commodity the desk quotes a daily price for, from
 * `GET /api/v5/commodities/` (`commodityPricesService`).
 */

/**
 * Which mark a row draws: the mock's four (an ingot for gold and silver, a drop, a cylinder). A row
 * with no kind drops (`lenientList`) rather than drawing a blank slot.
 */
export const commodityKindSchema = z.enum(['gold', 'silver', 'fuel', 'gas'])

export const commodityPriceSchema = z.object({
  /** Stable slug: "fine-gold", "silver", "petrol", "lpg". */
  key: z.string().min(1),
  /** "Fine gold". */
  name: z.string().min(1),
  /** What the price is per: "per tola", "per litre", "per cylinder". `null` when the source didn't say. */
  unit: z.string().min(1).nullable(),
  kind: commodityKindSchema,
  /** Today's price in rupees. */
  price: moneySchema,
  /** Since the previous quote: 0 is "Same", `null` (no earlier quote) shows no move. */
  change: moneySchema.nullable(),
  /** Decimals the MOVE is quoted in: 0 for a tola of gold, 2 for a litre of petrol. */
  deltaDecimals: z.union([z.literal(0), z.literal(2)]),
})

export const commodityPricesSchema = lenientList(commodityPriceSchema, 'commodity price')

export type CommodityKind = z.infer<typeof commodityKindSchema>
export type CommodityPrice = z.infer<typeof commodityPriceSchema>
